module.exports = __webpack_public_path__ + "static/media/mu_hraswo.b68e0a6f.ogg";